var React = require('react');

function DownInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.st0 {\n\t\t\tfill: currentColor;\n\t\t}\n\t"),React.createElement("path",{"className":"st0","d":"M17.2,26.7c-0.2-0.6-0.8-0.9-1.4-0.9h-4.5c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3V2.2\n\tC10.9,1,9.9,0,8.6,0S6.4,1,6.4,2.2v23.1c0,0.2-0.2,0.4-0.4,0.4H1.5c-0.6,0-1.1,0.4-1.4,0.9c-0.2,0.6-0.1,1.2,0.3,1.6l7.1,7.1\n\tc0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.8-0.2,1.1-0.4l7.1-7.1C17.3,27.9,17.4,27.2,17.2,26.7z","key":1})]);
}

DownInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 17.3 35.9","style":{"enableBackground":"new 0 0 17.3 35.9"},"xmlSpace":"preserve"};

module.exports = DownInline;

DownInline.default = DownInline;
